import { Request } from 'commons/utils/request'
import { WriteHook, useMutationManager } from 'state-manager'

const deleteDocumentPeriod = (id: number) => Request.delete(Request.urls.bank.documentPeriod, { id })

export const useDeleteDocumentPeriod: WriteHook<number, void> = (id) =>
  useMutationManager<number, void>(deleteDocumentPeriod, id)
